import { configureStore } from "@reduxjs/toolkit";
import { apiMiddleware, apiReducers } from "./api/apiSetup";
import counterSlice from "./slices/counterSlice";
import filterSlice from "./slices/filterSlice";
import authSlice from "./slices/authSlice";
import tagInputSlice from "./slices/tagInputSlice";
import cartSlice from "./slices/cartSlice";
import commonSlice from "./slices/commonSlice";
import jckFormSlice from "./slices/jckFormSlice";

export const store = configureStore({
  reducer: {
    counter: counterSlice,
    filter: filterSlice,
    auth: authSlice,
    tagInput: tagInputSlice,
    cart: cartSlice,
    common: commonSlice,
    jckForm: jckFormSlice,
    ...apiReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...apiMiddleware),
});
